import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.5 3.5L21.5 7.5M12.5 3.5L3.5 7.5M12.5 3.5V11.5M21.5 7.5L12.5 11.5M21.5 7.5L24.5 11.5L21.5 12.8333M12.5 11.5L3.5 7.5M12.5 11.5V21.5M12.5 11.5L15.5 15.5L21.5 12.8333M12.5 11.5L9.5 15.5L3.5 12.8333M3.5 7.5L0.5 11.5L3.5 12.8333M12.5 21.5L21.5 17.5V12.8333M12.5 21.5L3.5 17.5V12.8333",
    stroke: "currentColor",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */)

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode("TODO normalized SVG"),
    _hoisted_1
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
export default { render: render }